import {AuthRepositoryImpl} from '../repository/AuthRepositoryImpl';
import {LoginUseCase} from '../useCases/LoginUseCase';
import {CheckDashboardAccessUseCase} from '../useCases/CheckDashboardAccessUseCase';
import {CheckPermissionUseCase} from '../useCases/CheckPermissionUseCase';

class AuthFactory {
  private static instance: AuthFactory;
  private authRepository: AuthRepositoryImpl;
  private loginUseCase: LoginUseCase;
  private checkDashboardAccessUseCase: CheckDashboardAccessUseCase;
  private checkPermissionUseCase: CheckPermissionUseCase;

  private constructor () {
    this.authRepository = new AuthRepositoryImpl();
    this.loginUseCase = new LoginUseCase(this.authRepository);
    this.checkDashboardAccessUseCase = new CheckDashboardAccessUseCase();
    this.checkPermissionUseCase = new CheckPermissionUseCase();
  }

  static getInstance () {
    if (!AuthFactory.instance) {
      AuthFactory.instance = new AuthFactory();
    }
    return AuthFactory.instance;
  }

  getUseCases () {
    return {
      loginUseCase: this.loginUseCase,
      authRepository: this.authRepository,
      checkDashboardAccessUseCase: this.checkDashboardAccessUseCase,
      checkPermissionUseCase: this.checkPermissionUseCase
    };
  }
}

export const authFactory = AuthFactory.getInstance();
